﻿<script setup>
    import { useAuthStore } from './common/auth/authstore';
    const store = useAuthStore();
    const router = useRouter();

    const leftDrawerOpen = ref(false)

    function toggleLeftDrawer() {
        leftDrawerOpen.value = !leftDrawerOpen.value
    }

    function LogOut() {
        store.LogOut();
        router.go(0);
    }

    const validate = ref(true);
</script>

<template>
    <q-layout view="hHh lpR lFr">
        <q-header elevated class="bg-primary text-white">
            <q-toolbar>
                <q-btn dense flat round icon="menu" @click="toggleLeftDrawer" />

                <q-toolbar-title>
                    <img src="/logo_white.png" h-8 mt-2>
                </q-toolbar-title>

                <q-btn dense @click="LogOut" icon="lock" color="positive" :label="store.Auth.user" v-if="store.Auth" />
            </q-toolbar>
        </q-header>

        <q-drawer show-if-above v-model="leftDrawerOpen" side="left" bordered>
            <q-list>
                <q-item clickable v-ripple to="/shipping/released">
                    <q-item-section avatar>
                        <q-icon color="primary" name="local_shipping" />
                    </q-item-section>

                    <q-item-section>Shipping</q-item-section>
                </q-item>
                <q-item clickable v-ripple to="/scheduling/ready">
                    <q-item-section avatar>
                        <q-icon color="primary" name="watch_later" />
                    </q-item-section>

                    <q-item-section>Scheduling</q-item-section>
                </q-item>
                <q-item clickable v-ripple to="/production/active">
                    <q-item-section avatar>
                        <q-icon color="primary" name="factory" />
                    </q-item-section>

                    <q-item-section>Production</q-item-section>
                </q-item>

                <q-separator my-3 />

                <!--<q-item clickable v-ripple to="/salesorder/search">
                    <q-item-section avatar>
                        <q-icon color="primary" name="search" />
                    </q-item-section>

                    <q-item-section>Sales Order Search</q-item-section>
                </q-item>-->

                <q-item clickable v-ripple to="/fulfillment/search">
                    <q-item-section avatar>
                        <q-icon color="primary" name="search" />
                    </q-item-section>

                    <q-item-section>Pickup Search</q-item-section>
                </q-item>
            </q-list>
        </q-drawer>

        <q-page-container>
            <router-view />
        </q-page-container>

    </q-layout>
</template>

<style lang="scss">
    @import './variables.scss';

    @font-face {
        font-family: 'Inter-Regular';
        font-style: normal;
        src: local('Inter-Regular'), url(@/assets/Inter-Regular.ttf) format('truetype');
    }

    html {
        font-size: 100%;
    }
    /*16px*/

    body {
        background: white;
        font-family: 'Inter-Regular';
        font-weight: 400;
        line-height: 1.75;
        color: #000000;
        width: 100%;
    }

    a {
        cursor: pointer;
        color: #2653a6;
        text-decoration:none;
    }

    p {
        margin-bottom: .5rem;
        white-space: pre-wrap;
    }

    h1, h2, h3, h4, h5 {
        margin: 3rem 0 1.38rem;
        font-family: 'Poppins', sans-serif;
        font-weight: 400;
        line-height: 1.3;
    }

    h1, .h1 {
        margin-top: 0;
        font-size: 1.602rem;
    }

    h2, .h2 {
        font-size: 1.424rem;
    }

    h3, .h3 {
        font-size: 1.266rem;
    }

    h4, .h4 {
        font-size: 1.125rem;
    }

    h5, .h6 {
        font-size: 1rem;
    }

    small, .text_small {
        font-size: 0.889rem;
    }

    ul {
        padding:1rem;
        margin:0;
    }

    .menu-active {
        color: $primary;
        font-weight: bold;
    }

    .isdeleted {
        background-color: $deleted !important;
    }

    .q-table {
        thead tr th {
            font-weight: bold;
            background-color: #fff;
        }
    }
</style>
